// extracted by mini-css-extract-plugin
export default {"customer-entry":"customer-entry_nr_37","customerEntry":"customer-entry_nr_37","opacity":"opacity_Mmi4R"};